import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import facade1 from "./components/facade-1";
import facade2 from "./components/facade-2";
import facade3 from "./components/facade-3";
import facade4 from "./components/facade-4";

const principle: Slide = {
  description:
    "Choose between different outer wall/facade structures and see how the sound reduction index curve changes over frequency. Listen to everyday sounds in their original form and as they would be perceived through an outer wall/facade. Use headphones. Set the volume on your device so that original male voice sounds realistically loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Facade 1" }, { name: "Facade 2" }, { name: "Facade 3" }, { name: "Facade 4" }],
        },
      ],
      extraContent: [[], []],
      components: [facade1, facade2, facade3, facade4],
    },
  },
};

export default principle;
